import React, { useState } from 'react'
import * as Icon from 'react-feather';
const CardSolution = props => {
    const [checked, setChecked] = useState(props.checked)

    
    return (
        <div onClick={() => setChecked(!checked)} className="w-60 flex-shrink-0 animated fadeIn relative group cursor-pointer mr-4 mb-4 xl:mr-5 xl:mb-5">
            <div className="group-hover:bg-primary-light rounded-full w-6.5 h-4 border border-primary bg-white absolute right-0 top-0 mr-2 mt-2 flex justify-center items-center">
                {checked ? <Icon.Check className="text-primary w-4 mx-auto" /> : ""}
            </div>
            <div className={`border border-primary-light rounded-lg flex justify-center pb-4 pt-6 ${checked ? "bg-primary border-vp" : "bg-white group-hover:bg-primary-light group-hover:border-vp"}`}>
                <img src={props.logo} alt="Geozone" />
            </div>
            <div className={`border border-primary-light rounded-lg flex justify-center py-4 px-4 min-h-43.5 text-xse ${checked ? "bg-primary text-white border-vp" : "bg-white group-hover:bg-primary-light group-hover:border-vp"} `}>
                <ul className="list-disc pl-3 font-semibold" style={{letterSpacing: -0.2}}>
                    {props.features.map((e,i) => <li key={i} className="mb-1 last:mb-0">{e}</li>)}                   
                </ul>
            </div>
            <div className={`border border-primary-light rounded-lg justify-center py-3 px-4 font-bold text-xxs bg-white group-hover:bg-primary-light group-hover:border-vp ${checked ? "bg-primary-light border-vp" : ""} `}>
                <div className="text-xxs mb-1">Beneficiary Departments:</div>

                <div className="flex -mr-3 flex-wrap">
                    
                {props.departments.map((e,i) => <div key={i} className="w-6 h-6 mr-3 mb-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full hoveref">{e.cardname}<div key={i} className="hoverpz">{e.cardhover}</div></div>)}

                                 
                </div>

                <div className="text-xxs">Level of difficulty to operate:</div>
                <div className="inline-block px-1 py-1 rounded-md bg-vp-peach font-bold text-xxs">
                    {props.diffultyLevel}
                </div>
            </div>
            <div className={`bg-white border flex font-bold text-primary rounded-lg justify-center px-2 py-1.5 ${checked ? "border-vp" : "border-primary-light"} group-hover:border-vp`}>
                {props.learnMoreLink ? <a href={props.learnMoreLink} rel="noopener noreferrer" target="_blank">Learn More</a> : ""}
                {props.demoLink ? <>&nbsp; |&nbsp; <a href={props.demoLink} rel="noopener noreferrer" target="_blank">Demo</a></> : ""}
            </div>
        </div>
    )
}


export default CardSolution
